import {
    SET_DEMANDES_RECRUTEMENT_LOADING,
    SET_DEMANDES_RECRUTEMENT_ERROR,

    FETCH_DEMANDES_RECRUTEMENT_SUCCESS,
    FETCH_DEMANDES_RECRUTEMENT_FAIL,

    CREATE_DEMANDE_RECRUTEMENT_FAIL,
    UPDATE_DEMANDE_RECRUTEMENT_FAIL,

    DELETE_DEMANDE_RECRUTEMENT_SUCCESS,
    DELETE_DEMANDE_RECRUTEMENT_FAIL,

    APPROVE_DEMANDE_RECRUTEMENT_SUCCESS,
    APPROVE_DEMANDE_RECRUTEMENT_FAIL,

    REJECT_DEMANDE_RECRUTEMENT_SUCCESS,
    REJECT_DEMANDE_RECRUTEMENT_FAIL,

    CANCEL_DEMANDE_RECRUTEMENT_SUCCESS,
    CANCEL_DEMANDE_RECRUTEMENT_FAIL,
    SEND_OFFER_TO_CHASSEURS_REQUEST,
    SEND_OFFER_TO_CHASSEURS_SUCCESS,
    SEND_OFFER_TO_CHASSEURS_FAIL,
    SEND_OFFER_TO_PARTENAIRES_REQUEST,
    SEND_OFFER_TO_PARTENAIRES_SUCCESS,
    SEND_OFFER_TO_PARTENAIRES_FAIL,
    CLEAR_RECRUTEMENT_EMAIL_STATE,
} from "../actions/demandesRecrutementActions";


const initialState = {
    loading: false,
    error: null,
    demandes: [],
    sendingOfferToChasseurs: false,
    sendingOfferToPartenaires: false,
    sendOfferSuccess: '',
    sendOfferError: null,
};

export default function demandesRecrutementReducer(state = initialState, action) {
    switch (action.type) {
        case SET_DEMANDES_RECRUTEMENT_LOADING:
            return { ...state, loading: !!action.payload };

        case SET_DEMANDES_RECRUTEMENT_ERROR:
            return { ...state, error: action.payload };

        case FETCH_DEMANDES_RECRUTEMENT_SUCCESS:
            return {
                ...state,
                demandes: action.payload || [],
                error: null,
            };

        case APPROVE_DEMANDE_RECRUTEMENT_SUCCESS:
        case REJECT_DEMANDE_RECRUTEMENT_SUCCESS:
        case CANCEL_DEMANDE_RECRUTEMENT_SUCCESS:
            return {
                ...state,
                demandes: (state.demandes || []).map((d) =>
                    d.id === action.payload.id ? action.payload : d
                ),
                error: null,
            };

        case FETCH_DEMANDES_RECRUTEMENT_FAIL:
        case CREATE_DEMANDE_RECRUTEMENT_FAIL:
        case UPDATE_DEMANDE_RECRUTEMENT_FAIL:
        case DELETE_DEMANDE_RECRUTEMENT_FAIL:
        case APPROVE_DEMANDE_RECRUTEMENT_FAIL:
        case REJECT_DEMANDE_RECRUTEMENT_FAIL:
        case CANCEL_DEMANDE_RECRUTEMENT_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_DEMANDE_RECRUTEMENT_SUCCESS:
            return {
                ...state,
                demandes: (state.demandes || []).filter((d) => d.id !== action.payload),
                error: null,
            };

        case SEND_OFFER_TO_CHASSEURS_REQUEST:
            return {
                ...state,
                sendingOfferToChasseurs: true,
                sendOfferSuccess: '',
                sendOfferError: null,
            };

        case SEND_OFFER_TO_CHASSEURS_SUCCESS:
            return {
                ...state,
                sendingOfferToChasseurs: false,
                sendOfferSuccess: 'Offre envoyée aux chasseurs sélectionnés avec succès',
            };

        case SEND_OFFER_TO_CHASSEURS_FAIL:
            return {
                ...state,
                sendingOfferToChasseurs: false,
                sendOfferError: action.error,
            };

        case SEND_OFFER_TO_PARTENAIRES_REQUEST:
            return {
                ...state,
                sendingOfferToPartenaires: true,
                sendOfferSuccess: '',
                sendOfferError: null,
            };

        case SEND_OFFER_TO_PARTENAIRES_SUCCESS:
            return {
                ...state,
                sendingOfferToPartenaires: false,
                sendOfferSuccess: 'Offre envoyée aux partenaires sélectionnés avec succès',
            };

        case SEND_OFFER_TO_PARTENAIRES_FAIL:
            return {
                ...state,
                sendingOfferToPartenaires: false,
                sendOfferError: action.error,
            };

        case CLEAR_RECRUTEMENT_EMAIL_STATE:
            return {
                ...state,
                sendingOfferToChasseurs: false,
                sendingOfferToPartenaires: false,
                sendOfferSuccess: '',
                sendOfferError: null,
            };

        default:
            return state;
    }
}